<ion-list mode="ios" lines="none" class="list-content">
  <!-- * Imagen -->
  <ion-item mode="md" lines="none" color="white">
    <ion-img
      [src]="'Icons.red-blue-document' | translate"
      class="img-document"
    ></ion-img>
  </ion-item>

  <!-- * Nombre y titulo -->
  <ion-item mode="md" lines="none" color="white" class="ion-text-center">
    <ion-label mode="md" color="darkblue" class="responsable">
      {{ responsable | async }}
      <p class="update-legals mpe-font-weight-600">
        {{ 'Labels.update-legals' | translate }}
      </p>
    </ion-label>
  </ion-item>

  <!-- * Intro -->
  <ion-item mode="md" lines="none" color="white" class="ion-text-center">
    <ion-label
      mode="md"
      class="improve-handling-protection-personal-data-review-following"
    >
      {{ 'Labels.improve-handling-protection-personal-data-review-following' |
      translate }}
    </ion-label>
  </ion-item>

  <!-- * T&C -->
  <form [formGroup]="legalesForm" (ngSubmit)="formSubmit()">
    <ng-container *ngFor="let item of legales">
      <ion-item
        mode="md"
        lines="none"
        color="white"
        class="item-checkbox mpe-no-focused"
      >
        <ion-checkbox
          color="darkblue"
          mode="md"
          class="checkbox"
          [formControlName]="item.ID_LegalTipo"
          (ionChange)="changeStatusCheck($event, item.ID_LegalTipo)"
        ></ion-checkbox>

        <ion-label
          mode="md"
          color="darkblue"
          class="legals-text"
          (click)="onLegals(item)"
        >
          <span> {{ 'Labels.' + item.tipo | translate }} </span>
        </ion-label>
      </ion-item>
    </ng-container>

    <!-- * Boton Aceptar -->
    <ion-item mode="md" lines="none" color="white">
      <ng-container *ngIf="!loading">
        <ion-button
          class="button-accept"
          size="default"
          mode="md"
          color="darkblue"
          type="submit"
          [disabled]="legalesForm.invalid"
        >
          <ion-label mode="md" color="white">
            {{ 'Buttons.accept' | translate }}
          </ion-label>
        </ion-button>
      </ng-container>

      <ng-container *ngIf="loading">
        <ion-button
          class="button-accept mpe-button-center"
          size="default"
          mode="md"
          color="darkblue"
          type="button"
          disabled="true"
        >
          <ion-spinner color="white" name="crescent"></ion-spinner>
          <ion-label mode="md" color="white">
            {{ 'Buttons.accept' | translate }}
          </ion-label>
        </ion-button>
      </ng-container>
    </ion-item>
  </form>
</ion-list>
